/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Searchlanguages1Inputs */

const id_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari bahasa...`)
};

const ms_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari bahasa...`)
};

const da_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg efter sprog...`)
};

const de_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen durchsuchen...`)
};

const en_us2_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search languages...`)
};

const es_es2_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar idiomas...`)
};

const es_mx2_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar idiomas...`)
};

const fil_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng mga wika...`)
};

const fr_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des langues…`)
};

const it_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca lingue...`)
};

const hu_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyelvek keresése...`)
};

const nl_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talen zoeken...`)
};

const no_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk etter språk...`)
};

const pl_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj języków...`)
};

const pt_br2_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar idiomas...`)
};

const pt_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar idiomas...`)
};

const ro_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută limbi...`)
};

const fi_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae kieliä...`)
};

const sv_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök språk...`)
};

const vi_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm ngôn ngữ...`)
};

const tr_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilleri ara...`)
};

const cs_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat jazyky...`)
};

const bg_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене на езици...`)
};

const ru_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск языков...`)
};

const uk_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук мов...`)
};

const ar_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث عن لغات...`)
};

const hi_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषाएँ खोजें...`)
};

const th_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาภาษา...`)
};

const ja_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語を検索...`)
};

const zh_cn2_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索语言...`)
};

const zh_hant1_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋語言...`)
};

const ko_nav_searchlanguages1 = /** @type {(inputs: Nav_Searchlanguages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언어 검색...`)
};

/**
* | output |
* | --- |
* | "Search languages..." |
*
* @param {Nav_Searchlanguages1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_searchlanguages1 = /** @type {((inputs?: Nav_Searchlanguages1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Searchlanguages1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_searchlanguages1(inputs)
	if (locale === "ms") return ms_nav_searchlanguages1(inputs)
	if (locale === "da") return da_nav_searchlanguages1(inputs)
	if (locale === "de") return de_nav_searchlanguages1(inputs)
	if (locale === "en-US") return en_us2_nav_searchlanguages1(inputs)
	if (locale === "es-ES") return es_es2_nav_searchlanguages1(inputs)
	if (locale === "es-MX") return es_mx2_nav_searchlanguages1(inputs)
	if (locale === "fil") return fil_nav_searchlanguages1(inputs)
	if (locale === "fr") return fr_nav_searchlanguages1(inputs)
	if (locale === "it") return it_nav_searchlanguages1(inputs)
	if (locale === "hu") return hu_nav_searchlanguages1(inputs)
	if (locale === "nl") return nl_nav_searchlanguages1(inputs)
	if (locale === "no") return no_nav_searchlanguages1(inputs)
	if (locale === "pl") return pl_nav_searchlanguages1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_searchlanguages1(inputs)
	if (locale === "pt") return pt_nav_searchlanguages1(inputs)
	if (locale === "ro") return ro_nav_searchlanguages1(inputs)
	if (locale === "fi") return fi_nav_searchlanguages1(inputs)
	if (locale === "sv") return sv_nav_searchlanguages1(inputs)
	if (locale === "vi") return vi_nav_searchlanguages1(inputs)
	if (locale === "tr") return tr_nav_searchlanguages1(inputs)
	if (locale === "cs") return cs_nav_searchlanguages1(inputs)
	if (locale === "bg") return bg_nav_searchlanguages1(inputs)
	if (locale === "ru") return ru_nav_searchlanguages1(inputs)
	if (locale === "uk") return uk_nav_searchlanguages1(inputs)
	if (locale === "ar") return ar_nav_searchlanguages1(inputs)
	if (locale === "hi") return hi_nav_searchlanguages1(inputs)
	if (locale === "th") return th_nav_searchlanguages1(inputs)
	if (locale === "ja") return ja_nav_searchlanguages1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_searchlanguages1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_searchlanguages1(inputs)
	return ko_nav_searchlanguages1(inputs)
});
export { nav_searchlanguages1 as "nav.searchLanguages" }